export default __webpack_public_path__ + "static/media/011-season.b6cea4cb.svg";